/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcInventoryV1TradingDayState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_INVENTORY_V1_TRADING_DAY_STATE_ENTITY_NAME = 'ixc.inventory.v1.TradingDay';
export const ixcInventoryV1TradingDayStateEntity = new schema.Entity<IxcInventoryV1TradingDayState>(IXC_INVENTORY_V1_TRADING_DAY_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcInventoryV1TradingDayState) => `${entity.assetId}-${entity.date}` });

